<template>
  <div class="my-profile-card" v-if="user
  ">
    <div class="col-avatar">
      <b-img
        rounded="circle"
        width="88"
        fluid
        :src="user.avatar.url"
        :alt="user.nickname"
        v-if="user && user.avatar"
      />
    </div>
    <div
      class="user-medals"
      v-if="(user.tournaments && user.tournaments.length) || (user.clubs && user.clubs.length)"
    >
      <router-link
        v-for="tournament in user.tournaments"
        :key="tournament.id"
        :to="{ name: 'TournamentSingle', params: { id: tournament.to_param } }"
        v-b-tooltip.placement="'bottomright'"
        variant="primary"
        v-b-tooltip.hover
        :title="tournament.name"
      >
        <b-img-lazy :src="tournament.badge.thumb.url"></b-img-lazy>
      </router-link>
      <router-link
        v-for="club in user.clubs"
        :key="club.id"
        :to="{ name: 'ClubSingle', params: { id: club.to_param } }"
        v-b-tooltip.placement="'bottomright'"
        variant="primary"
        v-b-tooltip.hover
        :title="club.name"
      >
        <b-img-lazy :src="club.badge.thumb.url"></b-img-lazy>
      </router-link>
    </div>
    <div class="col-stats">
      <h1 class="user-name">
        <router-link :to="{ name: 'UserSingle', params: { id: user.to_param }}">{{user.nickname}}</router-link>
      </h1>

      <!--  LEVEL
      KILLS HOJE-->

      <div class="stats-box">
        <div class="stat-box">
          <p class="heading">KDR</p>
          <p class="title">{{ user.kdr }}</p>
        </div>
        <div class="stat-box">
          <p class="heading">ADR</p>
          <p class="title">{{ user.adr }}</p>
        </div>
        <div class="stat-box">
          <p class="heading">KILLS</p>
          <p class="title">{{ user.kills }}</p>
        </div>
        <div class="stat-box">
          <p class="heading">HS%</p>
          <p class="title">{{ user.headshot_percentage }}</p>
        </div>
        <div class="stat-box">
          <p class="heading">HLTVSCORE</p>
          <p class="title">{{ user.hltv_score }}</p>
        </div>
      </div>
    </div>

    <div class="col-level" v-b-tooltip.hover title="considerando as ultimas 7 partidas">
      <p>level</p>
      <h1>{{ userLevel }}</h1>
    </div>
  </div>
</template>

<script>
export default {
  name: "MyProfileCard",
  computed: {
    userLevel: function() {
      if (this.user.ranked_level == "level_rank_a") return "A";
      else if (this.user.ranked_level == "level_rank_b") return "B";
      else if (this.user.ranked_level == "level_rank_c") return "C";
      else if (this.user.ranked_level == "level_rank_d") return "D";
      else if (this.user.ranked_level == "level_rank_e") return "E";
      else return "?";
    }
  },
  data() {
    return {
      user: { avatar: { url: "" } }
    };
  },
  methods: {
    initialize() {
      this.$http
        .get(`users/${this.currentUser.id}.json`)
        .then(response => (this.user = response.data));
    }
  },
  mounted() {
    this.initialize();
  },
  components: {}
};
</script>

<style scoped lang="sass">
.my-profile-card
  border-radius: 4px
  background: rgba(255, 255, 255, .1)
  padding: 10px
  color: rgba(255, 255, 255, .75)
  position: relative

  display: flex
  @media (max-width: 600px)
    flex-wrap: wrap

  .col-avatar
    margin-right: 20px
  
  .col-stats
    position: relative
    h1.user-name
      margin: 0
      a
        color: rgba(255, 255, 255, .55)
        transition: all .2s
        &:hover
          color: rgba(255, 255, 255, .76)
          text-decoration: none

    .stats-box
      display: flex
      justify-content: space-between
      padding: 0
      margin-top: 10px
      width: 320px
      color: rgba(255, 255, 255, .45)
      .stat-box
        p
          margin: 0
        p.heading
          text-transform: uppercase
          font-size: 12px
          line-height: 2px
        p.title
          font-weight: bold
          font-size: 18px
          font-family: 'Oswald', monospace
  .user-medals
    position: absolute
    bottom: 10px
    left: 10px
    // display: flex
    a
      width: 24px
      height: 24px
      display: inline-block
      margin-right: 3px

      img
        width: 100%
        height: 100%
  .col-level
    margin-left: auto
    align-self: center
    text-align: center
    padding-top: 10px
    padding: 10px 10px 0
    p
      margin: 0
      text-transform: uppercase
      text-align: center
      font-size: 12px
      line-height: 2px
      font-weight: bold
    h1
      margin: 0
</style>
